import { AppTitle } from '@otomoro/components/shared/AppTitle'
import { PortableText, PortableTextComponents } from 'next-sanity'
import { styles, StylesVariants } from './PromotionalCard.css'
import { PortableTextObject } from 'sanity'
import { AppText } from '@otomoro/components/shared/AppText'
import { Button, SanityButtonProps } from '@otomoro/components/shared/Button'
import { resolveHref } from '@otomoro/sanity/lib/sanity.links'
import { SectionHeader } from "../SectionHeader"

interface PromotionalCardProps extends StylesVariants {
	tag: string
	title: PortableTextObject
	description: PortableTextObject
	button: {
		title: string
		_type: 'linkInternal' | 'linkExternal'
		pageType: string
		slug: string
		anchor: string
		url: string
		newWindow: boolean
	}
}

export const PromotionalCard: React.FC<PromotionalCardProps> = ({
	tag,
	title,
	description,
	button,
}) => {
	const descriptionComponents = {
		block: {
			normal: ({ children }: any) => (
				<AppText as="p" size="base" color="black" weight="medium">
					{children}
				</AppText>
			),
		},
		marks: {
			highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
		},
	} as PortableTextComponents

	const { base, heading, content } = styles()

	return (
		<aside className={base()}>
			<SectionHeader className={heading()} tag={tag} title={title} theme="pink" noPx />
			<div className={content()}>
				<PortableText value={description} components={descriptionComponents} />
				{button && (
					<Button
						as="nextLink"
						variant="secondary"
						href={
							button._type === 'linkInternal'
								? resolveHref(button.pageType, button.slug, button.anchor)
								: button.url
						}
						target={button._type === 'linkExternal' && button.newWindow ? '_blank' : undefined}
						className="w-fit "
					>
						{button.title}
					</Button>
				)}
			</div>
		</aside>
	)
}
